/**
 * "Nova versão pronta · Atualizar" — o Service Worker é `prompt`, não
 * `autoUpdate`, para não recarregar no meio de um formulário. O aviso é o
 * toque que faltava: `main.tsx` dispara `nv:update-available` e ninguém
 * ouvia, então uma versão nova só entrava depois de fechar o app de vez.
 */
import { useEffect, useState } from 'react';

export function NovaVersao() {
  const [aplicar, setAplicar] = useState<(() => Promise<void>) | null>(null);
  const [aplicando, setAplicando] = useState(false);

  useEffect(() => {
    const ouvir = (e: Event) => {
      const detalhe = (e as CustomEvent<{ apply: () => Promise<void> }>).detail;
      if (detalhe?.apply) setAplicar(() => detalhe.apply);
    };
    window.addEventListener('nv:update-available', ouvir);
    return () => window.removeEventListener('nv:update-available', ouvir);
  }, []);

  if (!aplicar) return null;
  return (
    <div className="sync-badge nova-versao" role="status" aria-live="polite" data-testid="nova-versao">
      <span className="sync-badge__label">Nova versão pronta</span>
      <button
        type="button"
        className="sync-badge__action nova-versao__botao"
        disabled={aplicando}
        onClick={() => {
          setAplicando(true);
          void aplicar();
        }}
      >
        {aplicando ? 'Atualizando…' : 'Atualizar'}
      </button>
    </div>
  );
}
